import { create } from "zustand";
import { log, settings } from "@tumbodash/browserPackages";

interface PlayerState {
	playerId: string;
}

interface PlayerStore {
	player: PlayerState | null;
	initialized: boolean;
	creating: boolean;
	init: () => Promise<void>;
	getPlayerId: () => string | null;
	updatePlayerId: (newId: string) => void;
	updatePlayer: (newPlayer: PlayerState) => void;
}

const usePlayerStore = create<PlayerStore>((set, get) => ({
	player: null,
	initialized: false,
	creating: false,

	init: async () => {
		log.fx("(stores/player:init)");
		if (get().initialized || get().creating) return;

		set({ creating: true });

		try {
			let playerId = localStorage.getItem("playerId");

			if (!playerId) {
				const res = await fetch(`${settings.serverUrl}player/createId`);
				const data = await res.json() as { playerId: string };
				playerId = data.playerId;
				localStorage.setItem("playerId", playerId);
			}

			set({ player: { playerId }, initialized: true, creating: false });
		} catch (err) {
			set({ creating: false });
			throw err;
		}
	},

	getPlayerId: () => get().player?.playerId ?? null,

	updatePlayerId: (newId) => {
		localStorage.setItem("playerId", newId);
		set((state) => ({
			player: { ...(state.player ?? {}), playerId: newId },
		}));
	},

	updatePlayer: (newPlayer) => {
		set({ player: structuredClone(newPlayer) });
	},
}));

export default usePlayerStore;
